import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { i as EGDSLayoutFlex, j as EGDSLayoutFlexItem } from '../layout-flex-item/index-chunk.esm.js';
import { c as classNames, b as EGDSContextWrapper } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-checkbox.css';

const getClassNameList$1 = classNames.bind(styles);
class EGDSCheckbox extends React.Component {
    static displayName = 'EGDSCheckbox';
    static defaultProps = {
        checked: false,
    };
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.checked !== prevState.checked) {
            return {
                checked: nextProps.checked,
            };
        }
        return null;
    }
    useReducedMotion = false;
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked,
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        // On mount set mediaQuery to check if user has reduced motion enabled
        this.useReducedMotion =
            typeof window.matchMedia === 'function' && window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
    }
    handleChange(e) {
        const { onChange } = this.props;
        const { checked } = this.state;
        this.setState({ checked: !checked });
        if (onChange) {
            onChange(e);
        }
    }
    render() {
        const { className, children, description, disabled, errorMessage, id, indeterminate, labelClassName, labelSuffix, name, required, value, defaultChecked, a11yLabel, domRef, } = this.props;
        const { checked } = this.state;
        if (checked && defaultChecked) {
            console.error('Both checked and defaultChecked prop can`t be set it as true');
        }
        const checkedProp = defaultChecked ? 'defaultChecked' : 'checked';
        const checkedVal = defaultChecked || checked;
        const baseCssClass = 'uitk-checkbox';
        const wrapperClassNames = getClassNameList$1(baseCssClass, {
            'is-disabled': disabled,
        });
        const labelCssClassNames = getClassNameList$1(`uitk-checkbox-label`, {
            [labelClassName]: Boolean(labelClassName),
            'uitk-checkbox-label-haslabelsuffix': labelSuffix,
            'is-required': required,
        });
        const inputClassNames = getClassNameList$1({
            checked,
        });
        const iconClassNames = getClassNameList$1('uitk-checkbox-icon');
        const controlClassNames = getClassNameList$1(`${baseCssClass}-control`);
        const contentClassNames = getClassNameList$1(`${baseCssClass}-content`);
        const labelContentClassNames = getClassNameList$1(`${baseCssClass}-label-content`);
        const labelSuffixClassNames = getClassNameList$1(`${baseCssClass}-label-suffix`);
        const descriptionClassNames = getClassNameList$1(`${baseCssClass}-description uitk-type-200`);
        const errorClassNames = getClassNameList$1(`${baseCssClass}-error`);
        const controlAndReducedMotionClassNames = [
            controlClassNames,
            getClassNameList$1(`${baseCssClass}-has-reduced-motion`),
        ];
        const contents = children;
        // Forces screen reader to pause when reading a label with multiple parts
        const ariaLabel = a11yLabel || [contents, labelSuffix, description].filter((elem) => !!elem).toString();
        return (jsx(EGDSContextWrapper, { children: (context, data) => (jsxs(EGDSLayoutFlex, { className: wrapperClassNames, wrap: "nowrap", children: [jsx(EGDSLayoutFlexItem, { shrink: 0, className: className, children: jsx("input", { type: "checkbox", name: name || id, id: id, [checkedProp]: checkedVal, className: inputClassNames, disabled: disabled, onChange: this.handleChange, value: value, ref: domRef, "aria-describedby": errorMessage ? `${id}-error` : undefined, "aria-invalid": errorMessage ? true : undefined, "aria-required": required, "aria-checked": indeterminate ? 'mixed' : undefined, "aria-label": ariaLabel }) }), jsx(EGDSLayoutFlexItem, { className: this.useReducedMotion ? controlAndReducedMotionClassNames : controlClassNames, shrink: 0, children: jsx("span", { "aria-hidden": "true", children: checkedVal && jsx(EGDSIcon, { name: indeterminate ? 'remove' : 'check', className: iconClassNames }) }) }), jsx(EGDSLayoutFlexItem, { className: contentClassNames, grow: 1, children: jsxs("div", { children: [jsxs("label", { className: labelCssClassNames, htmlFor: id, children: [jsxs("p", { className: labelContentClassNames, children: [contents, required && data?.hasRequiredFieldIndicator && (jsxs("span", { className: "uitk-checkbox-required-asterisk", "aria-hidden": "true", children: [' ', "*"] }))] }), labelSuffix && jsx("p", { className: labelSuffixClassNames, children: labelSuffix }), description && jsx("p", { className: descriptionClassNames, children: description })] }), errorMessage && (jsx("p", { className: errorClassNames, id: `${id}-error`, children: errorMessage }))] }) })] })) }));
    }
}

const getClassNameList = classNames.bind(styles);
class EGDSCheckboxGroup extends React.Component {
    static displayName = 'EGDSCheckboxGroup';
    render() {
        const { children, errorMessage, group, legendLabel } = this.props;
        return (jsx(EGDSContextWrapper, { children: (context, data) => (jsxs("fieldset", { className: getClassNameList('uitk-checkbox-group'), children: [jsxs("legend", { className: getClassNameList('is-visually-hidden'), children: [legendLabel || group, data?.collapsed && (data?.srMessage ? `. ${data?.srMessage}` : '')] }), errorMessage && (jsx("p", { className: getClassNameList('uitk-checkbox-error', 'uitk-checkbox-group-error'), children: errorMessage })), children] })) }));
    }
}

export { EGDSCheckbox as E, EGDSCheckboxGroup as a };
//# sourceMappingURL=index-chunk.esm.js.map
